export function assembleDropdown(items) {
  return items
    .map((s) => {
      return {
        id: s.key,
        text: s.value,
      };
    })
    .sort(function (a, b) {
      return a.text.localeCompare(b.text);
    });
}
